import { memo } from 'react';
import { useParams } from 'react-router-dom';
import { EquipmentList as AdminEquipmentList } from '@/admin-pages/Equipments/EquipmentList';

export default memo(function EquipmentList() {
  const { orgId } = useParams<{ orgId: string }>();
  return (
    <AdminEquipmentList orgId={Number(orgId)} />
  );
});
